<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-toolbar-title>Move EDN '{{ value.ednNumber }}'</v-toolbar-title>
            <slot name="header"></slot>
        </v-toolbar>
        <v-card-text>
            Move EDN for
            <strong>{{value.unitNumber}}</strong> to
            <strong>{{garageName}}</strong>?
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <slot name="actions"></slot>
            <v-btn color="primary" @click="submitForm">Move</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import moment from 'moment';

export default {
    props: {
        value: {
            required: true
        }
    },
    methods: {
        async init() {
            this.id = this.value.id;
            this.newGarageId = this.value.unitGarageId;
            this.garageName = this.value.unitGarageName;
            this.submitted = false;
        },
        async submitForm() {
            this.submitted = true;
            this.$emit('move', { id: this.id, newGarageId: this.newGarageId });
            this.$nextTick(() => {
                this.submitted = false;
            });
        }
    },
    data() {
        return {
            id: '',
            newGarageId: null,
            garageName: ''
        };
    }
};
</script>

<style lang="scss" scoped>
</style>
